export default Object.freeze({
  PROPERTY: 1,
  RESEARCH: 2,
});
